/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../../tools/typings/tsd.d.ts"/>
/// <reference path="../../components.ts"/>

namespace DealerwareWebComponents {
    'use strict';

    export class AdditionalDriversDirectiveController {
        public static $inject : string[] = [
            'DealerwareAdditionalDriverModel',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$scope',
            '$filter',
            '$mdDialog',
            '$dealerwareInternationalizationDateFormats', 
            '$dealerwareInternationalizationData'
        ];

        constructor(
            public DealerwareAdditionalDriverModel: any,
            public $dealerwareLoading: any,
            public $dealerwareNotification: any,
            public $scope: any,
            public $filter: any,
            public $mdDialog: any,
            public $dealerwareInternationalizationDateFormats: any, 
            public $dealerwareInternationalizationData: any
        ) {
            this.lang = this.$dealerwareInternationalizationDateFormats.language();
            this.format = this.$dealerwareInternationalizationDateFormats.formats[this.lang];
            this.getLabels('contracts');
        };

        public contract          : any;
        public additionalDrivers : {}[];
        public listView          : boolean = true;
        public formView          : boolean = false;
        public selectedDriver    : any;
        public stateRequired     : boolean;
        public showDriverButtons : boolean;
        public driverIndex       : number;
        public lang              : string; 
        public format            : string;
        public labels            : {};

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public showAddButton() : boolean {
            return this.contractNotStarted() && this.additionalDrivers && this.additionalDrivers.length < 2;
        }

        public contractNotStarted() : boolean {
            var unstartedStates: string[] = ['booked', 'pending_agreement', 'no_showed', 'payment_declined'];
            var state: string = this.contract.contractDetails &&
                this.contract.contractDetails.data &&
                this.contract.contractDetails.data.current_state;
            
            var bool = unstartedStates.indexOf(state) > -1;
            this.showDriverButtons = bool;
            return bool;
        }

        public showMaxDriversMessage() : boolean {
            return this.additionalDrivers && this.additionalDrivers.length >= 2;
        }

        public cancelForm() : void {
            this.listView = true;
            this.formView = false;
        }

        public save() : void {
            this.selectedDriver.data.id ? this.updateDriver() : this.addDriver();
        }

        public addDriver() : void {
            var _self = this;
            var loader = _self.$dealerwareLoading.show('Saving...');

            _self.selectedDriver.$create({
                promise: true,
                params: {
                    location_id: _self.contract.locationId,
                    reservation_id: _self.contract.contractId
                }
            })
            .then(
                function(response : any) {
                    _self.listView = true;
                    _self.formView = false
                    loader.close();
                    _self.additionalDrivers.push(response);
                },
                function(error: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(error);
                }
            )
        }

        public stateLabel(driver : any) : string {
            if (driver && driver.data.country) {
                return driver.data.country === 'US' ? 'State' :
                    driver.data.country === 'CA' ? 'Province' : 'State/Province';
            }

            return 'State/Province';
        }

        public setStateRequired() : void {
            this.selectedDriver.data.drivers_license_state = undefined;
            if (this.selectedDriver) {
                this.stateRequired = this.selectedDriver.data.country === 'US' || this.selectedDriver.data.country === 'CA';
            }
        }

        public removeDriver(driver : any) : void {
            var _self = this;
            var textContent = `Are you sure you want to remove ${driver.data.first_name} ${driver.data.last_name}?`;
            this.$mdDialog.show(this.$mdDialog.confirm()
                .textContent(textContent)
                .ariaLabel(textContent)
                .cancel('Cancel')
                .ok('Remove'))
                .then(() => {
                    var loader = _self.$dealerwareLoading.show('Removing Driver...');

                    driver.$delete({
                        promise: true,
                        params: {
                            location_id: _self.contract.locationId,
                            reservation_id: _self.contract.contractId,
                            id: driver.data.id
                        }
                    })
                    .then(
                        function (response: any) {
                            _self.additionalDrivers.splice(_self.additionalDrivers.indexOf(driver), 1);
                            loader.close();
                        },
                        function (error: any) {
                            loader.close();
                            _self.$dealerwareNotification.apiError(error);
                        }
                    )
                }
            );
        }

        public openDriverForm(driver: any) {
            this.listView = false;
            this.formView = true;
            this.$scope.additionalDriverForm.$setPristine();
            this.$scope.additionalDriverForm.$setUntouched();
            this.selectedDriver = driver ? angular.copy(driver) : new this.DealerwareAdditionalDriverModel({ country: 'US' });
            this.driverIndex = this.additionalDrivers.indexOf(driver)
            this.stateRequired = this.selectedDriver.data.country === 'US' || this.selectedDriver.data.country === 'CA';         
        }

        public updateDriver() : void {
            var _self = this;
            var loader = _self.$dealerwareLoading.show('Updating Driver...');

            _self.selectedDriver.$update({
                promise: true,
                params: {
                    location_id: _self.contract.locationId,
                    reservation_id: _self.contract.contractId,
                    id: _self.selectedDriver.data.id
                }
            })
            .then(
                function (response: any) {
                    _self.listView = true;
                    _self.formView = false
                    _self.additionalDrivers.splice(_self.driverIndex, 1, response);
                    loader.close();
                },
                function (error: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(error);
                }
            )
        }

        public formatDate(date) {
            return moment(date).format(this.$dealerwareInternationalizationDateFormats.formats[this.lang]);
        }
    }

    getDealerwareWebComponentsModule()
        .controller('AdditionalDriversDirectiveController', AdditionalDriversDirectiveController);
    
    export class AdditionalDriversDirective implements ng.IDirective {
        public restrict         : string = 'EA';
        public controller       : string = 'AdditionalDriversDirectiveController';
        public controllerAs     : string = 'additionalDriversController';
        public bindToController : boolean = true;
        public scope            : Object = {
            additionalDrivers: '=',
            contract: '='
        };
        public templateUrl      : string = '/components/contract/additional_drivers/additional_drivers_directive.html';
        public static $inject   : string[] = [];

        constructor() {}

        public link: ng.IDirectiveLinkFn = (
            scope: ng.IScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            ctrls: any
        ) => { }
    }
    
    getDealerwareWebComponentsModule()
        .directive('dealerwareAdditionalDrivers', () => new AdditionalDriversDirective());
}